module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cadastro-de-aporte"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('section', [_c('main', {
    staticClass: "conteudo-principal columns"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande"
  }, [_vm._v("Preencha os campos abaixo para cadastrar o aporte.")]), _vm._v(" "), (_vm.projeto != null) ? _c('h3', {
    staticClass: "subtitle is-5"
  }, [_vm._v("\n            Adicione o valor do aporte para o projeto "), _c('strong', [_vm._v(_vm._s(this.projeto.Nome))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valorDoAporte"
    }
  }, [_vm._v("Aporte")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aporte.Valor),
      expression: "aporte.Valor"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "valorDoAporte",
      "type": "text",
      "id": "valorDoAporte",
      "placeholder": "Insira o valor do aporte",
      "required": ""
    },
    domProps: {
      "value": (_vm.aporte.Valor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.aporte, "Valor", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_2"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "dataDoAporte"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('span', [_vm._v(_vm._s(_vm.$tempo.formatarParaPadraoBrasileiro(new Date())))])])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('router-link', {
    staticClass: "botao botao_medio botao_cinza",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'ListaDeAportes',
        params: {
          projetoId: this.projeto.Id
        }
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.gerenciarCadastroDoAporte
    }
  }, [_vm._v("Salvar aporte")])], 1)])])])])], 1), _vm._v(" "), (_vm.modalDeConfirmacaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeConfirmacao
    }
  }, [_c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlertaModal
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cadastrarAporte.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Incluir aporte")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao"
  }, [_vm._v("\n          Após a confirmação da inclusão, não será possível edição ou exclusão.\n          ")]), _c('hr'), _vm._v("\n          Incluir R$ " + _vm._s(this.aporte.Valor) + " no projeto "), _c('strong', [_vm._v(_vm._s(this.projeto.Nome))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna u-sem-margem u-texto-alinhado-a-direita"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeConfirmacao
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295dbd44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aportes/CadastroDeAporte.vue
// module id = 1100
// module chunks = 1